import axios from 'axios'
import Vue from 'vue'
import { Toast } from 'vant';
var baseURL = process.env.VUE_APP_APP_HOST || 'https://api-test.shunxin.cn/'
var appid = process.env.VUE_APP_APPID
axios.defaults.baseURL=baseURL
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.async=true
axios.defaults.crossDomain=true
axios.defaults.withCredentials = true
import czParms from './utilSign.js'

// 过滤重复点击的接口
let filterInterface = []
let dataToken = new Date().getTime()

axios.interceptors.request.use(config => {
    Vue.prototype.$showLoading({
        title: '加载中···'
    });
    var userToken = sessionStorage.getItem('userToken');
    if(userToken){
        config.headers.common={
            "EFFICACY-USER-SESSION-KEY":userToken
        }
    }
    if(!filterInterface.includes(config.url)){
        config.headers["DATA-TOKEN"] = dataToken
    }
    config.params={
        appId:appid,
        timestamp:Math.round((new Date().getTime())/1000),
        ...config.params
    }
    var sign=''
    var header = config.headers["Content-Type"]
    if(header=='application/json'){
        sign= czParms(Object.assign({"jsonBody":config.data},config.params));
    }else{
        var obj={}
        var array1 = []   //key数组
        var array2 = []   //val数组
        if(config.data && typeof config.data == 'string'){
            var paramStr = config.data
            paramStr = paramStr.split('&')
            paramStr.forEach(item => {
                array1 = array1.concat(item.split("=")[0])
                array2 = array2.concat(item.split("=")[1])
            })
            array1.forEach((item,index) => {
                obj[item]=array2[index]
            })
            sign= czParms(Object.assign(obj,config.params));
        }else{
            // console.log(config.url)
            var obj2 = Object.assign({},config.data)
            sign= czParms(Object.assign(obj2?obj2:{},config.params));
        }

    }
    config.params={
        sign:sign,
        ...config.params
    }
    return config;
},function (error) {
    Vue.prototype.$cancelLoading();
    return Promise.reject(error)
})

axios.interceptors.response.use(function(response){
    Vue.prototype.$cancelLoading();
    dataToken = new Date().getTime()
    const res = response.data
    if(res.code != 0){
        // 请勿快速重复点击
        console.log(res.message,axios,'funcode')
        if(res.message !== '授权失败' && res.message !== '请勿快速重复点击'){
            Toast.fail(res.message);
        }
        console.error(response)
        return Promise.reject(new Error(res.message || 'Error'))
    }else {
        return res
    }
}, function(error){
    Vue.prototype.$cancelLoading();
    dataToken = new Date().getTime()
    console.log(error.message.indexOf('401'),'func')
    if(error.message.indexOf('401')<=-1){
        Toast.fail(error.message);
    }
    return Promise.reject(error)
})

export default axios
